<template>
    <SlideProductsDesktop v-if="block.platform == 1" :block="block" :border-width="borderWidth" :relative-viewport="relativeViewport"></SlideProductsDesktop>
    <SlideProductsMobile v-else :block="block"></SlideProductsMobile>
</template>
<script>
import SlideProductsDesktop from '../../Desktop/Blocks/SlideProducts';
import SlideProductsMobile from '../../Mobile/Blocks/SlideProducts';
import HomeBlock from '@/models/home-block';
export default {
    components:{
        SlideProductsDesktop,
        SlideProductsMobile
    },
    props:{
        block:{
            type: HomeBlock
        },
        relativeViewport: { // TODO  @sergio .... i need feedback on this
            type: Boolean,
            default: false
        },
        borderWidth:{
            type: Number,
            default: 2
        },
    },
    created(){
        if(this.block.diamond){
            this.block.initDiamondData();
        }
    }
}
</script>